import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, Pagination, Space, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';


const MBRTable = ({ dataSource, width="auto" }) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  })
  
  if(!dataSource && !dataSource.length) return null;

  let columns = Object.keys(dataSource[0]).map(item => ({ title: item, dataIndex: item })).filter(col => col.title !== 'style');

  const data = dataSource.map((item, index) => ({ ...item, key: index }))

  columns = columns.map((item, index) => {
    if(index === 0) {
      return {
        ...item,
        fixed: "left"
      }
    } else {
      return item;
    }
  })


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const startIdx = (pagination.current - 1) * pagination.pageSize;
  const endIdx = startIdx + pagination.pageSize;
  const displayData = data.slice(startIdx, endIdx);



  const getColumnSearchProps = (dataIndex) => ({
    // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    //   <div style={{ padding: 8 }}>
    //     <Input
    //       ref={searchInput}
    //       placeholder={`Search ${dataIndex}`}
    //       value={selectedKeys[0]}
    //       onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
    //       onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
    //       style={{ marginBottom: 8, display: 'block' }}
    //     />
    //     <Space>
    //       <Button
    //         onClick={() => handleReset(clearFilters)}
    //         size="small"
    //         style={{ width: 90 }}
    //       >
    //         Reset
    //       </Button>
    //       <Button
    //         onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
    //         icon={<SearchOutlined />}
    //         size="small"
    //         style={{ width: 90, background: "#00538A", color: "white" }}
    //       >
    //         Search
    //       </Button>
          
    //     </Space>
    //   </div>
    // ),
    // filterIcon: (filtered) => (
    //   <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    // ),
    // onFilter: (value, record) =>
    //   record[dataIndex]
    //     ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    //     : '',
    // filterDropdownProps: (visible) => {
    //   if (visible) {
    //     setTimeout(() => searchInput.current?.select(), 100);
    //   }
    // },
    render: (text, record) => {
      return {
        props: {
          style: record.style
        },
        children: text
      }
    }
      // searchedColumn === dataIndex ? (
      //   <Highlighter
      //     highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
      //     searchWords={[searchText]}
      //     autoEscape
      //     textToHighlight={text ? text.toString() : ''}
      //   />
      // ) : (
      //   text
      // ),
  });

  
  // Add search props to each column
  const columnsWithSearch = columns.map(col => ({
    ...col,
    ...getColumnSearchProps(col.dataIndex),
  }));

  const handlePageChange = (page, pageSize) => {
    setPagination({ ...pagination, current: page, pageSize })
  }
  
  return (
    <div style={{ width: width }}>
      <Table size='small' 
        className="mbr-table" 
        columns={columnsWithSearch} 
        dataSource={displayData} 
        onRow={(record) => {
          return {
            style: {
              fontWeight: record.Compliant === 'Total' ? 'bold' : 'normal',
            },
          };
        }}
        scroll={{ x: 'max-content' }} 
        pagination={false}
         />

      <Pagination
        style={{ marginTop: "5px" }}
        current={pagination.current} 
        pageSize={pagination.pageSize}
        total={data.length}
        onChange={handlePageChange}
      />
    </div>
  )
}

export default MBRTable;